<template>
  <div class="user-container" ref="usercontainer">
    <el-row class="user-button">
      <el-button type="primary" @click="dialogAddFormVisible = true"><i class="el-icon-plus"></i>新增展陈</el-button>
    </el-row>

    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="民族烽火" name="first">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"> </el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="奋起抵抗" name="second">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="浴血奋战" name="third">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="不屈不挠" name="fourth">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="时代强音" name="fifth">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="英灵永驻" name="sixth">
          <el-row>
            <el-col :span="6" v-for="item in displayList" :key="item.index" style="margin: 0 0 20px;">
              <div class="grid-content bg-purple" style="padding:0 10px;">
                <img :src="item.imgsrc" style="width: 100%;">
                <h4>{{item.title}}</h4>
                <p style="text-align: right">
                  <el-button size="mini" type="primary" icon="el-icon-edit"></el-button>
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteData(item)"></el-button>
                </p>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>

      </el-tabs>
    </template>

    <!--新增展陈-->
    <!-- Form -->
    <el-dialog title="新增展陈" :visible.sync="dialogAddFormVisible">
      <el-form :model="addForm" style="text-align: left">
        <el-form-item label="展陈标题" :label-width="formLabelWidth">
          <el-input v-model="addForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="展陈图片"  :label-width="formLabelWidth">
          <el-upload
              action="/api/common/upload"

              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handSuccess"
              list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>

        <el-form-item label="所属类别" :label-width="formLabelWidth" style="width:60%">
          <el-select v-model="addForm.columnId" placeholder="请选择所属类别" >
            <el-option label="民族烽火" value=1></el-option>
            <el-option label="奋起抵抗" value=2></el-option>
            <el-option label="浴血奋战" value=3></el-option>
            <el-option label="不屈不挠" value=4></el-option>
            <el-option label="时代强音" value=5></el-option>
            <el-option label="英灵永驻" value=6></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="addForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="offPage()">取 消</el-button>
        <el-button type="primary" @click="addSubmit(addForm)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Form -->

  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "DisplayAdmin",
  data(){
    return{
      dialogAddFormVisible:false,
      activeName: 'first',
      formLabelWidth:'120px',
      dialogImageUrl: '',
      dialogVisible: false,
      restfulUrl:'displays',
      addForm:{
        title:'',
        imgsrc:'',
        columnId:'',
        sort:1
      },
      displayList:[]
    }
  },
  methods:{
    handleClick(tab) {
      var columnData = parseInt(tab.index)+1;

      this.getDataByColumn({columnId:columnData})
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.addForm.imgsrc = file.url;
      this.dialogVisible = true;
    },
    handSuccess(response){
      this.addForm.imgsrc = response.data;
    },
    addSubmit(data){
      if(!this.addForm.title){
        console.log("请输入标题")
        return false
      }
      if(!this.addForm.columnId){
        console.log("请输入类别")
        return false
      }
      if(!this.addForm.imgsrc){
        console.log("请上传图片")
        return false
      }
      data.columnId = parseInt(data.columnId);
      data.sort = parseInt(data.sort);
      request({
        method:'POST',
        url:'/displays',
        data:data
      }).then(res =>{
        console.log(res)
        console.log(data)
        this.getDataByColumn({columnId:data.columnId});
        this.dialogAddFormVisible = false;
        if(data.columnId == 1){
          this.activeName = 'first';
        }
        else if(data.columnId == 2){
          this.activeName = 'second'
        }
        else if(data.columnId == 3){
          this.activeName = 'third'
        }
        else if(data.columnId == 4){
          this.activeName = 'fourth'
        }
        else if(data.columnId == 5){
          this.activeName = 'fifth'
        }
        else{
          this.activeName = 'sixth'
        }
        this.$message({
          type: 'success',
          message: '新增成功!',
        });

      },err=>{
        console.log(err)
      })

      console.log(data)
    },
    offPage(){
      this.dialogAddFormVisible = false;
      this.addForm={title:'', imgsrc:'', columnId:'',sort:1}
    },
    getDataByColumn(data){
      request({
        method:'POST',
        url:'/displays/getcolumn',
        data:data
      }).then(res =>{
        console.log(res)
        this.displayList = res.data
      },err=>{
        console.log(err)
      })
    },
    deleteData(data){
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除用户请求
        this.deleteById(data.id);
        this.getDataByColumn({columnId:data.columnId});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    deleteById:function(uid){
      request({
        method:'DELETE',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '删除成功!',
          });

        }
      },err=>{
        console.log(err)
      })
    },
  },
  mounted() {
    this.getDataByColumn({columnId:1})
  }
}
</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);
}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}
</style>
